import { render, staticRenderFns } from "./addCandidateToGroup.vue?vue&type=template&id=21289777&scoped=true"
import script from "./addCandidateToGroup.vue?vue&type=script&lang=js"
export * from "./addCandidateToGroup.vue?vue&type=script&lang=js"
import style0 from "./addCandidateToGroup.vue?vue&type=style&index=0&id=21289777&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21289777",
  null
  
)

export default component.exports